var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';
import MUISwitch from '@mui/material/Switch';
import { formControlLabelStyles } from './Switch.style';
import { colorPalette } from '../../colorPalette';
export const Switch = (props) => {
    const { dataQa = 'switch', label = '', labelPlacement = 'start', error = false } = props, otherProps = __rest(props, ["dataQa", "label", "labelPlacement", "error"]);
    return (React.createElement(FormControl, { error: !!error },
        React.createElement(FormControlLabel, { control: React.createElement(MUISwitch, Object.assign({}, otherProps, { "data-qa": `${dataQa}-core`, sx: {
                    '& .V5Switch-track, & .MuiSwitch-track': {
                        outline: error ? `1px solid ${colorPalette.red700}` : 'none',
                    }
                } })), "data-qa": `${dataQa}-formControlLabel`, label: label, labelPlacement: labelPlacement, sx: formControlLabelStyles }),
        typeof error === 'string' && (React.createElement(FormHelperText, { className: `MuiCheckbox-errorLabelPlacement-${labelPlacement}` }, error))));
};
